import * as React from 'react';
import { useLocalizer } from './hooks/useLocalizer';

interface AIDeleteSuccessToastProps {
    title: string;
    description: string;
    show: boolean;
    onClose: () => void;
}

export const AIDeleteSuccessToast: React.FC<AIDeleteSuccessToastProps> = ({ title, description, show, onClose }) => {
    const localize = useLocalizer();

    if (!show) {
        return null;
    }

    return (
        <div
            className="alert alert-danger ai-success-toast"
            role="status"
            aria-live="polite"
        >
            <button
                type="button"
                className="ai-success-toast-close"
                aria-label={localize('Close')}
                onClick={onClose}
            >
                <span aria-hidden="true">&times;</span>
            </button>
            <div className="ai-success-toast-title">{title}</div>
            <div className="ai-success-toast-description">{description}</div>
        </div>
    );
};

export default AIDeleteSuccessToast;
